module.exports = __webpack_public_path__ + "images/emoji/pig2.c4f1146cf7be4967634c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pig2.png
// module id = 7bbe
// module chunks = 14